import { useEffect, useState } from "react";
import { get, patchRequest } from "../../../http/api";

export default function SportProfile() {
  const [role, setRole] = useState(null);
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  /* FETCH ROLE + DATA */
  useEffect(() => {
    fetchSportProfile();
  }, []);

  const fetchSportProfile = async () => {
    try {
      const res = await get("profile/sport-info");
      setRole(res.data.role);
      setForm(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  /* HANDLE CHANGE */
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setSuccess(false);
  };

  /* SAVE */
  const handleSave = async () => {
    setLoading(true);
    try {
      await patchRequest("profile/sport-info", form);
      setSuccess(true);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (!role) return null;

  return (
    <section className="settings-card">
      <h3>Profil sportif / professionnel</h3>

      {/* ATHLETE */}
      {role === "athlete" && (
        <>
          <label>Sport principal</label>
          <input
            name="sport"
            value={form.sport || ""}
            onChange={handleChange}
            placeholder="Football, Basketball..."
          />

          <label>Poste / Discipline</label>
          <input
            name="position"
            value={form.position || ""}
            onChange={handleChange}
            placeholder="Attaquant, Défenseur..."
          />

          <label>Niveau</label>
          <select
            name="level"
            value={form.level || ""}
            onChange={handleChange}
          >
            <option value="">Choisir</option>
            <option value="amateur">Amateur</option>
            <option value="semi-pro">Semi-pro</option>
            <option value="pro">Professionnel</option>
          </select>

          <label>Club actuel</label>
          <input
            name="current_club"
            value={form.current_club || ""}
            onChange={handleChange}
            placeholder="Nom du club"
          />

          <label>Années d’expérience</label>
          <input
            type="number"
            name="experience_years"
            value={form.experience_years || ""}
            onChange={handleChange}
          />

          <label>Disponible pour opportunités</label>
          <select
            name="available"
            value={form.available ?? ""}
            onChange={handleChange}
          >
            <option value="">—</option>
            <option value="1">Oui</option>
            <option value="0">Non</option>
          </select>
        </>
      )}

      {/* CLUB */}
      {role === "club" && (
        <>
          <label>Sport</label>
          <input
            name="sport"
            value={form.sport || ""}
            onChange={handleChange}
          />

          <label>Ligue / Niveau</label>
          <input
            name="league"
            value={form.league || ""}
            onChange={handleChange}
            placeholder="Division, ligue..."
          />

          <label>Année de création</label>
          <input
            type="number"
            name="founded_year"
            value={form.founded_year || ""}
            onChange={handleChange}
          />

          <label>Objectif principal</label>
          <select
            name="goal"
            value={form.goal || ""}
            onChange={handleChange}
          >
            <option value="">Choisir</option>
            <option value="recruitment">Recrutement</option>
            <option value="sponsoring">Sponsoring</option>
            <option value="visibility">Visibilité</option>
          </select>
        </>
      )}

      {/* BRAND */}
      {role === "brand" && (
        <>
          <label>Secteur</label>
          <input
            name="sector"
            value={form.sector || ""}
            onChange={handleChange}
            placeholder="Sportwear, Nutrition..."
          />

          <label>Sports ciblés</label>
          <input
            name="target_sports"
            value={form.target_sports || ""}
            onChange={handleChange}
            placeholder="Football, Fitness..."
          />

          <label>Type de collaboration</label>
          <select
            name="collaboration_type"
            value={form.collaboration_type || ""}
            onChange={handleChange}
          >
            <option value="">Choisir</option>
            <option value="sponsoring">Sponsoring</option>
            <option value="ambassador">Ambassadeur</option>
            <option value="event">Événement</option>
          </select>
        </>
      )}

      {/* LAWYER */}
      {role === "lawyer" && (
        <>
          <label>Spécialité</label>
          <input
            name="specialty"
            value={form.specialty || ""}
            onChange={handleChange}
            placeholder="Droit du sport..."
          />

          <label>Sports couverts</label>
          <input
            name="sports_covered"
            value={form.sports_covered || ""}
            onChange={handleChange}
          />

          <label>Années d’expérience</label>
          <input
            type="number"
            name="experience_years"
            value={form.experience_years || ""}
            onChange={handleChange}
          />
        </>
      )}

      <div className="settings-actions">
        <button
          className="btn primary"
          onClick={handleSave}
          disabled={loading}
        >
          {loading ? "Enregistrement..." : "Enregistrer"}
        </button>

        {success && <span className="success-msg">✔ Sauvegardé</span>}
      </div>
    </section>
  );
}